/**
 * Outbox — what is waiting to go out, what failed, and the hourly budget.
 *
 * Auto-refreshes while the screen is open: during a send the interesting part
 * is watching the backlog drain, and a manual refresh button gets old fast.
 */
define('mailingQueueView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  App,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var REFRESH_MS = 15000;

  var QueueView = Marionette.ItemView.extend({

    className: 'mailing-page mailing-queue',

    template: _.template(
      '<%= nav %>' +
      '<div class="mlg-tiles queue-tiles"></div>' +
      '<div class="mlg-toolbar">' +
      '  <select class="f-status">' +
      '    <option value="">All statuses</option>' +
      '    <option value="PENDING">Pending</option>' +
      '    <option value="SENDING">Sending</option>' +
      '    <option value="SENT">Sent</option>' +
      '    <option value="FAILED">Failed</option>' +
      '    <option value="SKIPPED">Skipped</option>' +
      '  </select>' +
      '</div>' +
      '<div class="mlg-body"><div class="mlg-loading">Loading outbox…</div></div>'
    ),

    ui: {
      tiles: '.queue-tiles',
      body: '.mlg-body',
      status: '.f-status'
    },

    events: {
      'change .f-status': 'load',
      'click .mlg-retry-failed': 'onRetryFailed',
      'click .mlg-cancel': 'onCancel'
    },

    serializeData: function () {
      return {
        nav: Shell.navHtml('queue',
          '<button type="button" class="mlg-btn mlg-retry-failed">Retry all failed</button>')
      };
    },

    onShow: function () {
      var self = this;
      this.load();
      this.timer = window.setInterval(function () { self.load(); }, REFRESH_MS);
    },

    onDestroy: function () {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
    },

    load: function () {
      var self = this;
      $.when(MailingApi.queueStats(), MailingApi.queue({ status: this.ui.status.val(), limit: 100 }))
        .done(function (stats, items) {
          self.renderTiles(stats);
          self.renderList(items || []);
        })
        .fail(function (xhr) {
          self.ui.body.html('<div class="mlg-error">' + _.escape(MailingApi.errorMessage(xhr)) + '</div>');
        });
    },

    renderTiles: function (stats) {
      var budget = stats.sentLastHour + ' / ' + stats.maxPerHour;
      var tiles = [
        { label: 'Pending', value: Shell.formatNumber(stats.pending) },
        { label: 'Sending', value: Shell.formatNumber(stats.sending) },
        { label: 'Sent today', value: Shell.formatNumber(stats.sentToday) },
        { label: 'Failed today', value: Shell.formatNumber(stats.failedToday),
          tone: stats.failedToday > 0 ? 'bad' : '' },
        { label: 'Last hour', value: budget,
          sub: 'hourly limit · ' + stats.delaySeconds + 's between sends',
          tone: stats.sentLastHour >= stats.maxPerHour ? 'warn' : '' }
      ];
      this.ui.tiles.html(_.map(tiles, function (tile) {
        return '<div class="mlg-tile ' + (tile.tone || '') + '">' +
          '<div class="t-value">' + tile.value + '</div>' +
          '<div class="t-label">' + _.escape(tile.label) + '</div>' +
          (tile.sub ? '<div class="t-sub">' + _.escape(tile.sub) + '</div>' : '') +
          '</div>';
      }).join(''));
    },

    renderList: function (items) {
      if (!items.length) {
        this.ui.body.html(Shell.emptyHtml('The outbox is empty.'));
        return;
      }
      var rows = _.map(items, function (item) {
        var status = item.status || 'PENDING';
        return '<tr data-secid="' + item.secId + '">' +
          '<td>' + _.escape(item.toEmail || '') + '</td>' +
          '<td>' + _.escape(item.subject || '') +
            '<div class="c-sub">' + _.escape(item.sourceName || '') + '</div></td>' +
          '<td><span class="mlg-chip st-' + status.toLowerCase() + '">' +
            Shell.prettyCase(status) + '</span>' +
            (item.attempts > 1 ? ' <span class="c-count">' + item.attempts + ' tries</span>' : '') + '</td>' +
          '<td>' + Shell.formatDate(item.sentAt || item.scheduledAt, true) + '</td>' +
          // For a skipped item this column holds the reason, not an error.
          '<td class="c-error" title="' + _.escape(item.errorMessage || '') + '">' +
            _.escape(item.errorMessage || '') + '</td>' +
          '<td class="c-actions">' +
            (status === 'PENDING' ? '<button type="button" class="mlg-btn small danger mlg-cancel">Cancel</button>' : '') +
          '</td></tr>';
      }).join('');

      this.ui.body.html(
        '<table class="mlg-table">' +
        '<thead><tr><th>To</th><th>Subject</th><th>Status</th><th>When</th><th>Error</th><th></th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>');
    },

    onRetryFailed: function () {
      var self = this;
      if (!window.confirm('Put every failed email back in the queue?')) { return; }

      MailingApi.retryFailed().done(function (result) {
        Shell.banner(self.$el, (result.requeued || 0) + ' email(s) requeued', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onCancel: function (e) {
      var self = this;
      var secId = $(e.currentTarget).closest('tr').data('secid');
      MailingApi.cancelQueueItem(secId).done(function () {
        Shell.banner(self.$el, 'Email cancelled', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    }
  });

  module.exports = QueueView;
});

